/**
 * Module dependencies.
 */

import { css, keyframes } from '@emotion/react';
import { ifProp } from 'styled-tools';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  width: 100%;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

/**
 * Export `Img` styled component.
 */

export const Img = styled.img<{ visible: boolean }>`
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;

  ${ifProp(
    'visible',
    css`
      animation: ${fadeIn} 0.5s ease-in-out forwards;
    `,
  )}
`;
